import React from 'react';
import { Modal } from 'antd';
import PasswordChangeForm from './PasswordChangeForm';

const PasswordChangeModal = ({
  visible,
  onCancel,
  onSuccess,
  title = "Change Password",
  description = "Update your password to keep your account secure",
  isAdminReset = false,
  userId = null
}) => {
  const handleSuccess = (result) => {
    if (onSuccess) {
      onSuccess(result);
    }
    onCancel(); // Close modal on success
  };

  return (
    <Modal
      title={null}
      open={visible}
      onCancel={onCancel}
      footer={null}
      width={600}
      centered
      destroyOnClose
      maskClosable={false}
    >
      <PasswordChangeForm
        onSuccess={handleSuccess}
        onCancel={onCancel}
        showCancel={true}
        title={title}
        description={description}
        isAdminReset={isAdminReset}
        userId={userId}
      />
    </Modal>
  );
};

export default PasswordChangeModal;




















